// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"PurchaseListTab_pageContent__2yCOs","filterBlock":"PurchaseListTab_filterBlock__1BZ_l","filterCell":"PurchaseListTab_filterCell__1HWHW"};